import {
	Routes,
	Route,
	useLocation,
	Navigate
} from 'react-router-dom'
import {
	loginRoutes,
	Routes as routes,
	WorkerRoutes as wroutes
} from '../routes'
import { RNLogin } from '../helpers/routeNames'
import { FC } from 'react'
import { Page404 } from '../pages/404'
import { User } from '../helpers/types/user'

interface AppRouterProps {
	isLoggedIn: boolean
	user: User | false
}

const AppRouter: FC<AppRouterProps> = ({ isLoggedIn, user }) => {
	const location = useLocation()

	return (
		<Routes location={location}>
			{isLoggedIn && user
				? user.role === 'worker'
					? wroutes.map(({ path, Element }) => {
							if (path === '*') {
								return (
									<Route
										key={404}
										path={'*'}
										element={<Page404 />}
									/>
								)
							}
							return (
								<Route
									key={path}
									path={path}
									element={<Element />}
								/>
							)
						})
					: user.role === 'admin' || user.role === 'supervisor'
						? routes.map(({ path, Element }) => {
								if (path === '*') {
									return (
										<Route
											key={404}
											path={'*'}
											element={<Page404 />}
										/>
									)
								}
								return (
									<Route
										key={path}
										path={path}
										element={<Element />}
									/>
								)
							})
						: ''
				: loginRoutes.map(({ path, Element }) => {
						if (path === '*') {
							return (
								<Route
									key={404}
									path={'*'}
									element={
										<Navigate to={RNLogin} />
									}
								/>
							)
						} else {
							return (
								<Route
									key={path}
									path={path}
									element={<Element />}
								/>
							)
						}
					})}
		</Routes>
	)
}

export default AppRouter
